<template>
  <div class="wrapper">
    <Tabs v-model="activeTab" @input="changeTab" class="empty-tab">
      <Tab
        :key="`tab-${index}`"
        v-for="(item, index) of authorizedTabs"
        :header="item.label"
      >
      </Tab>
    </Tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    Tabs,
    Tab,
  },

  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          label: "Événements",
          name: "dynamic-content-coach-app-special-events",
          requiredPermission: "DYNAMIC_CONTENT_COACH_APP_SPECIAL_EVENTS_READ",
        },
        {
          label: "Notes de mise à jour",
          name: "dynamic-content-coach-app-app-updates",
          requiredPermission: "DYNAMIC_CONTENT_COACH_APP_APP_UPDATES_READ",
        },
        {
          label: "Tutoriels",
          name: "dynamic-content-coach-app-tutorials",
          requiredPermission: "DYNAMIC_CONTENT_COACH_APP_TUTORIALS_READ",
        },
      ],
    };
  },

  computed: {
    authorizedTabs() {
      return this.tabs.filter((tab) => {
        return this.hasPermission(
          this.$store.state.user,
          tab.requiredPermission
        );
      });
    },
  },

  created() {
    this.setCurrentTab(this.$route.name);
  },

  methods: {
    changeTab(index) {
      if (index >= 0) {
        this.$router.push({ name: this.authorizedTabs[index].name });
      }
    },

    setCurrentTab(currentPath) {
      this.activeTab = this.authorizedTabs.findIndex(
        (tab) => tab.name === currentPath || tab.children?.includes(currentPath)
      );
    },
  },

  watch: {
    $route(current) {
      this.setCurrentTab(current.name);
    },
  },
};
</script>
